/* eslint-disable no-mixed-spaces-and-tabs */
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import ToolbarDropdown from './ToolbarDropdown';
import { BROKERAGE, FIELDS } from '@/utils/emailHelper';

const BrokerDropdown = ({ onChange }) => {
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;

	const { data: userDetails, ...userQuery } = useGetUserDetailsQuery({ email }, { skip: !email });
	const broker = userDetails?.broker;

	const fields = useMemo(() => {
		return FIELDS.filter((field) => field.type === BROKERAGE).map((field) => {
			const value = broker?.[field.value];
			const disabled =
				value == null ||
				(typeof value === 'object'
					? Array.isArray(value)
						? value.length === 0
						: Object.keys(value).length === 0
					: String(value ?? '').trim().length === 0);
			return {
				...field,
				disabled,
			};
		});
	}, [userDetails]);

	const getNodeValue = (event) => {
		const field = fields.find((v) => v.value === event.target.value);

		const templateAttr = `template-value="${field.type}.${field.value}"`;

		const value = broker?.[field.value] ?? '';
		const fspValue = value.toString().toLowerCase().includes('fsp') ? value : `FSP ${value}`;
		let node = `<${field.node} ${templateAttr}>${
			field.label.toLowerCase().includes('fsp') ? fspValue : value
		}</${field.node}>`;
		if (field.node === 'a') {
			node = `<a ${templateAttr} href="${
				field.label.toLowerCase().includes('email') ? `mailto:${value}` : value
			}">${field.label.toLowerCase().includes('email') ? value : field.label}</a>`;
		} else if (field.node === 'img') {
			node = `<img ${templateAttr} src="${value}" />`;
		}
		onChange(node);
	};

	return (
		<>
			<ToolbarDropdown title={'brokerage'} fields={fields} onChange={getNodeValue} />
		</>
	);
};

export default BrokerDropdown;
